import { render, staticRenderFns } from "./ReportsActiveTreatment.vue?vue&type=template&id=28276c87&"
import script from "./ReportsActiveTreatment.vue?vue&type=script&lang=js&"
export * from "./ReportsActiveTreatment.vue?vue&type=script&lang=js&"
import style0 from "./ReportsActiveTreatment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportsActiveTreatment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports